// Перечисление всех прав
export enum permissions {
  viewPage = 'viewPage',
  adminSystem = 'adminSystem',
  inviteListeners = 'inviteListeners',
  banUser = 'banUser',
}

// Перевод прав
export const permissionsTranslation: { [k: string]: string } = {
  [permissions.adminSystem]: 'Администрирование системы',
  [permissions.inviteListeners]: 'Приглашение сотрудников в систему',
  [permissions.banUser]: 'Блокировка/разблокировка пользователей',
}
